module.exports = __webpack_public_path__ + "static/media/plan-pro-badge.950e2055.png";